import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { fontSize, colors } from "@root/shared/styles/sprinkles.css";
import { type Rank } from "@userFrontend/features/promotion/types/type";
import * as styles from "./styles.css";

type Props = {
  rankNum: number;
  total: number;
  rank?: Rank;
};

const RankingIcon: FC<{ rank?: Rank }> = ({ rank }) => {
  if (rank === "gold") {
    return <Icon name="premium-scout" fontSize={fontSize["fs-24"]} color={colors.Gold} />;
  }
  if (rank === "silver") {
    return <Icon name="premium-scout" fontSize={fontSize["fs-24"]} color={colors.Silver} />;
  }
  if (rank === "bronze") {
    return <Icon name="premium-scout" fontSize={fontSize["fs-24"]} color={colors.Bronze} />;
  }
  return null;
};

export const RankingText: FC<Props> = ({ rank, rankNum, total }) => {
  return (
    <p className={styles.container}>
      <span className={styles.rank({ rank: rank ?? "other" })}>
        {rank && <RankingIcon rank={rank} />}
        <span className={styles.rankNum}>{rankNum}</span>位
      </span>
      <span className={styles.total}> / {total}人中 </span>
    </p>
  );
};
